var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-index-main"},[_c('el-empty',{attrs:{"description":"加载失败"}}),_c('button',{staticClass:"btn-text",on:{"click":_vm.refresh}},[_vm._v("刷新")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }